import { render, staticRenderFns } from "./AccidentFilter.vue?vue&type=template&id=64cd6403&scoped=true"
import script from "./AccidentFilter.vue?vue&type=script&lang=js"
export * from "./AccidentFilter.vue?vue&type=script&lang=js"
import style0 from "./AccidentFilter.vue?vue&type=style&index=0&id=64cd6403&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd6403",
  null
  
)

export default component.exports